import { render, staticRenderFns } from "./PassageQuestionForm.vue?vue&type=template&id=84e9c182&scoped=true&"
import script from "./PassageQuestionForm.vue?vue&type=script&lang=js&"
export * from "./PassageQuestionForm.vue?vue&type=script&lang=js&"
import style0 from "./PassageQuestionForm.vue?vue&type=style&index=0&id=84e9c182&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e9c182",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VBtn,VCheckbox,VIcon,VListItemContent,VListItemTitle,VTextField,VTextarea})
